<script>
  import Card from '../../../components/card.svelte'
  import VisibilityBadge from '../../../components/badges/visibility_badge.svelte'
  import ClickableImage from '../../../components/lightbox/clickable_image.svelte'
  import UserAvatar from '../../../components/user_avatar.svelte'
  import UserAvatarUploadModal from '../../../components/user_avatar_upload_modal.svelte'
  import { Button } from '../../../components/ui'

  // The Social tab itself requires manage_social — the same ability the avatar
  // endpoints check — so the upload action needs no further gating here.
  let { profile } = $props()

  let avatarModalOpen = $state(false)
  const iconUrl = $derived(profile.icon_image?.image_url ?? null)
  const avatarUser = $derived({ id: profile.id, name: profile.name, icon_image_url: iconUrl })

  const openAvatarModal = () => (avatarModalOpen = true)

  const stats = $derived([
    { label: 'Moments', value: profile.moments_count },
    { label: 'Friends', value: profile.friends_count },
    { label: 'Hypes Given', value: profile.hypes_given_count },
    { label: 'Hypes Received', value: profile.hypes_received_count }
  ])
</script>

<Card title="Profile">
  <div class="flex items-center gap-3 mb-5">
    {#if iconUrl}
      <ClickableImage url={iconUrl} title={profile.name || ''} thumbClass="h-14 w-14 rounded-full object-cover">
        {#snippet actions(close)}
          <Button variant="default" size="sm" icon="edit" onclick={() => { close(); openAvatarModal() }}>Change picture</Button>
        {/snippet}
      </ClickableImage>
    {:else}
      <UserAvatar size="lg" name={profile.name} title="Upload profile picture" onclick={openAvatarModal} />
    {/if}
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-2 flex-wrap">
        <VisibilityBadge visibility={profile.profile_visibility} />
      </div>
      <div class="flex items-center gap-3 flex-wrap">
        <Button variant="link" size="xs" class="px-0" onclick={openAvatarModal}>{iconUrl ? 'Change picture' : 'Upload profile picture'}</Button>
        {#if profile.icon_image}
          <a href="/user-icons" class="link link-hover text-xs">Review icons</a>
        {/if}
      </div>
    </div>
  </div>

  <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
    {#each stats as stat (stat.label)}
      <div>
        <div class="text-2xl font-semibold tabular-nums">{(stat.value ?? 0).toLocaleString()}</div>
        <div class="text-xs text-base-content/50">{stat.label}</div>
      </div>
    {/each}
  </div>
</Card>

<UserAvatarUploadModal bind:open={avatarModalOpen} user={avatarUser} only={['social', 'user']} />
